import { render, staticRenderFns } from "./shopCarCom.vue?vue&type=template&id=89b4ae6e&scoped=true&"
import script from "./shopCarCom.vue?vue&type=script&lang=js&"
export * from "./shopCarCom.vue?vue&type=script&lang=js&"
import style0 from "./shopCarCom.vue?vue&type=style&index=0&id=89b4ae6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b4ae6e",
  null
  
)

export default component.exports